<div class="row pv50 txt-center">
    <div class="loader"></div>
</div>